import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { I18nModule, TranslationService } from '@spartacus/core';
import { TableProComponent } from '../../../../../../components/table-pro/table-pro.component';
import { AnualPurchase, PurchaseSummaryDetailsRequest } from '../../../_core/models/purchase-summary.model';
import { BehaviorSubject, Subscription, take } from 'rxjs';
import { ReportsService } from '../../../_core/reports.service';
import { initialStatus, loadingStatus } from '../../../../../../core/models/request-status.model';
import { TableProConfig } from '../../../../../../components/table-pro/core/table-pro.model';
import { LocalLoaderComponent } from '../../../../../../components/loader/local-loader/local-loader.component';
import { AlertComponent } from '../../../../../../components/alert/alert.component';
import { Alert, ALERT_TYPE } from '../../../../../../components/alert/alert.model';

@Component({
  selector: 'purchase-summary-details',
  standalone: true,
  imports: [CommonModule, I18nModule, LocalLoaderComponent, AlertComponent, TableProComponent],
  templateUrl: './purchase-summary-details.component.html',
  styleUrl: './purchase-summary-details.component.scss',
})
export class PurchaseSummaryDetailsComponent implements OnInit, OnDestroy {
  @Input() data?: { item: AnualPurchase };
  request$ = new BehaviorSubject<PurchaseSummaryDetailsRequest>(initialStatus);
  subscription = new Subscription();

  tableConfig: TableProConfig = {
    classContainer: 'm-t-20',
    itemsPerPage: 50,
    hasItemsPerPageSelector: false,
    floattingBottom: true,
    collumnConfig: [
      { id: 'itemNumber', index: 0, type: 'text' },
      { id: 'productDescription', index: 1, type: 'text' },
      { id: 'quantity', index: 2, type: 'number' },
      { id: 'sellingPrice', index: 3, type: 'number' },
      { id: 'totalPrice', index: 4, type: 'number' },
    ],
  };

  alertDanger: Alert = {
    isActive: true,
    title: '',
    content: '',
    containerClass: 'm-t-20',
    hasCloseButton: false,
    type: ALERT_TYPE.DANGER,
  };

  constructor(
    private reportsService: ReportsService,
    private translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.getDetails();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getDetails() {
    this.request$.next(loadingStatus);

    this.subscription.add(
      this.translationService
        .translate('generic.error')
        .pipe(take(1))
        .subscribe(translation => {
          this.alertDanger.content = translation;
        }),
    );

    this.subscription.add(
      this.reportsService
        .getPurchaseSummaryDetails(this.data!.item.code!)
        .pipe(take(1))
        .subscribe(response => {
          this.request$.next(response);
        }),
    );
  }
}
